.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 22px;
  border-radius: var(--radius-md);
  border: 1px solid transparent;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.15s ease,
    box-shadow 0.2s ease;
  white-space: nowrap;
}

.button:hover {
  transform: translateY(-1px);
}

.primary {
  background: linear-gradient(135deg, var(--color-purple) 0%, #6d28d9 100%);
  color: #fff;
  box-shadow: 0 4px 20px rgba(124, 58, 237, 0.35);
}

.primary:hover {
  box-shadow: 0 6px 28px rgba(124, 58, 237, 0.45);
}

.secondary {
  background: transparent;
  border-color: var(--color-border-strong);
  color: var(--color-gold-bright);
}

.secondary:hover {
  background: rgba(200, 161, 102, 0.08);
}

.gold {
  background: linear-gradient(135deg, #d4a85a 0%, var(--color-gold) 100%);
  color: #1a1208;
  box-shadow: 0 4px 16px rgba(200, 161, 102, 0.25);
}

.ghost {
  background: rgba(255, 255, 255, 0.04);
  border-color: var(--color-border);
  color: var(--color-text);
}

.ghost:hover {
  background: rgba(255, 255, 255, 0.08);
}
